// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3_DU1","content":"styles_content__2cTfW","selectAll":"styles_selectAll__2r68o"};